import gql from "graphql-tag";

export const deleteSearchableField = gql`
  mutation deleteSearchableField(
    $input: DeleteSearchableFieldInput!) {
    deleteSearchableField(input: $input) {
      project {
        id
        collections {
          id
          index
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
          searchableFields {
            field
            model
          }
        }
      }
    }
  }
`;

export const deleteSearchableFieldOptions = {
  name: "deleteSearchableField",
};
